// Present is conclusive; absent is not — the first load after an install stamps too late (UNS-4945).

// Also inlined as a literal in _posthog_snippet.html.slim, which runs in <head> long before this bundle
// loads and so cannot import it. posthog_spec.rb pins the two together; rename in both or neither.
const PRESENCE_ATTRIBUTE = 'data-unscreen-extension';

export function extensionPresent() {
  return document.documentElement.hasAttribute(PRESENCE_ATTRIBUTE);
}
